import MostDepartmentCard from './MostDepartmentCard.gql';

export default MostDepartmentCard;
